export default __webpack_public_path__ + "static/media/MVRDV-slide-02.ab647f2c.jpg";